import { useCallback, useState, useEffect } from 'react';
import { DeviationWorkflowAction } from 'src/infra/types/deviation';
import { usePaymentRecalculationToastSelector } from 'src/presentations/components/organisms/actionDetails/paymentRecalculationToast/PaymentRecalculationToastSelector';
import { useToastResult } from 'src/presentations/components/molecules/toast/useToastResult';
import { useShipmentSelector } from 'src/presentations/components/organisms/actionDetails/ShipmentSelector';
import { useInvoiceSummaryFromParams, usePerformDeviationWorkflowAction } from './useInvoices';

interface IUseReadyForPayment {
  setIsShowConfirm: (value: boolean) => void;
  onNotAsync: () => void;
}

/**
 * Hook for handling the ready for payment functionality
 * @returns Functions and state for handling ready for payment
 */
// export const useReadyForPayment = (props: IUseReadyForPayment) => {
//   const { setIsShowConfirm } = props;
//   const [isLoading, setIsLoading] = useState<boolean>(false);
//   const [isShowActionResult, setIsShowActionResult] = useState<boolean>(false);

//   console.log('isLoading', isLoading);

//   const { data: invoiceSummary } = useInvoiceSummaryFromParams();
//   const { shipment: shipmentDetail } = useShipmentSelector();

//   console.log('[DEBUG][useReadyForPayment] Invoice summary:', invoiceSummary);
//   console.log('[DEBUG][useReadyForPayment] shipmentDetail:', shipmentDetail);

//   const invoiceId = invoiceSummary?.id;
//   const { mutateAsync: performDeviationWorkflowAction } = usePerformDeviationWorkflowAction();
//   const { setCurrentInvoiceId, setCurrentShipmentNumber, setCurrentInvoiceNumber, setIsShowSuccessInfo } = usePaymentRecalculationToastSelector();
//   const { showToastResult } = useToastResult();

//   /**
//    * Handle ready for payment action
//    */
//   const handleReadyForPayment = useCallback(async () => {
//     setIsLoading(true);
//     setTimeout(() => {
//       console.log('settimout')

//       setCurrentInvoiceId(invoiceSummary?.id);
//       setCurrentInvoiceNumber(invoiceSummary?.invoiceNumber);
//       setCurrentShipmentNumber(shipmentDetail?.shipmentDetail?.shipmentNumber);
//       setIsLoading(false);
//       setIsShowConfirm(false);
//       setIsShowSuccessInfo(true);
//     }, 3000);
//   }, []);

//   return {
//     isLoading,
//     isShowActionResult,
//     setIsShowActionResult,
//     handleReadyForPayment,
//   };
// };

export const useReadyForPayment = (props: IUseReadyForPayment) => {
  const { setIsShowConfirm, onNotAsync } = props;
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { data: invoiceSummary } = useInvoiceSummaryFromParams();
  const { shipment: shipmentDetail } = useShipmentSelector();

  const invoiceId = invoiceSummary?.id;
  const { mutateAsync: performDeviationWorkflowAction } = usePerformDeviationWorkflowAction();
  const { confirmAsyncInvoice, setCurrentInvoiceId, setCurrentInvoiceNumber, setCurrentShipmentNumber } = usePaymentRecalculationToastSelector();

  /**
   * Handle ready for payment action
   */
  const handleReadyForPayment = useCallback(async () => {
    setIsLoading(true);

    try {
      const actionResponse = await performDeviationWorkflowAction({
        invoiceId,
        deviationWorkflowAction: DeviationWorkflowAction.READY_FOR_PAYMENT,
      });

      if (actionResponse?.data?.data?.asyncProcessing) {
        setCurrentInvoiceId(invoiceSummary?.id);
        setCurrentInvoiceNumber(invoiceSummary?.invoiceNumber);
        setCurrentShipmentNumber(shipmentDetail?.shipmentDetail?.shipmentNumber);

        await confirmAsyncInvoice({
          invoiceId,
          deviationWorkflowAction: DeviationWorkflowAction.READY_FOR_PAYMENT,
          onCloseConfirm: () => setIsShowConfirm(false),
        });
      } else {
        onNotAsync();
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [
    performDeviationWorkflowAction,
    invoiceId,
    confirmAsyncInvoice,
    onNotAsync,
    invoiceSummary?.id,
    invoiceSummary?.invoiceNumber,
    setCurrentInvoiceId,
    setCurrentInvoiceNumber,
    setCurrentShipmentNumber,
    shipmentDetail?.shipmentDetail?.shipmentNumber,
    setIsShowConfirm,
  ]);

  return {
    isLoading,
    handleReadyForPayment,
  };
};
